import { triggerModal } from './triggerModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: triggerData } = await triggerModal(oldData, node)

  if (triggerData && Object.values(triggerData).length > 0) {
    Object.assign(node.data, triggerData)
    node.update()
    updateNodeConnections(node)
  }


  return false
}